import React from "react";
import { Form, withFormik, Field } from "formik";
import * as yup from "yup";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardBody from "components/Card/CardBody.jsx";

// @material-ui/icons
import Apps from "@material-ui/icons/Apps";
import Assignment from "@material-ui/icons/Assignment";
import AssignmentInd from "@material-ui/icons/AssignmentInd";
import Memory from "@material-ui/icons/Memory";
import ButtonIcon from "../../components/styled/ButtonIcon";

import Save from "@material-ui/icons/Save";
import Cancel from "@material-ui/icons/Cancel";

import InfoInstance from "./components/InfoInstance";
import IndentityIntance from "./components/IndentityIntance";
import ContactIntance from "./components/ContactIntance";
import DateTestIntance from "./components/DateTestInstance";
import AIInstance from "./components/AIInstance";
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import ImageUploader from "react-images-upload";

const editOportunityFormSchema = yup.object().shape({
  name: yup.string().required(),
  appType: yup.number().required(),
  address: yup.string().required(),
  category: yup.number().required(),
  phone: yup.string().required(),
  description: yup.string().required(),
  webPage: yup.string().required(),
  maxAppUsers: yup.number().required(),
  instanceStatus: yup.string().required(),
  requirementDescription: yup.string().required(),
  identification: yup.object().shape({
    type: yup.number().required(),
    value: yup.string().required()
  }),
  contact: yup.object().shape({
    name: yup.string().required(),
    phone: yup.string().required(),
    email: yup.string().required()
  }),
  token: yup.string().required(),
  firebaseProject: yup.number(),
  language: yup.string(),
});

const EditOpportunityForm = props => {
  // Formik bag
  const {
    errors,
    touched,
    setFieldValue,
    submitForm,
    cities,
    instanceType,
    values,
    updateAppToken,
    archivedAllappTokens,
    paginationState
  } = props;
  const { t } = useTranslation("instances");
  return (
    <Form>
      <GridContainer>
        <GridItem xs={6}>
          <GridContainer>
            <GridItem xs={12}>
              <Card>
                <CardHeader>
                  <CardIcon color="info">
                    <Apps />
                  </CardIcon>
                  <h4>{t("instances.new.dataInfo")}</h4>
                </CardHeader>
                <CardBody>
                  <InfoInstance
                    updateAppToken={updateAppToken}
                    values={values}
                    errors={errors}
                    touched={touched}
                    cities={cities}
                    setFieldValue={setFieldValue}
                    editOpportunity={true}
                  />
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12}>
              <Card>
                <CardHeader>
                  <CardIcon color="info">
                    <Apps />
                  </CardIcon>
                  <h4>{t("instances.specialPermissions.title")}</h4>
                </CardHeader>
                <CardBody>
                  <List>
                    <ListItem>
                      <ListItemText
                        primary={t(
                          "instances.specialPermissions.archivedTokens"
                        )}
                      />
                      <ListItemSecondaryAction>
                        <IconButton
                          edge="end"
                          aria-label="archivar"
                          onClick={archivedAllappTokens}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </ListItemSecondaryAction>
                    </ListItem>
                  </List>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12}>
              <Card>
                <CardHeader>
                  <CardIcon color="info">
                    <Memory />
                  </CardIcon>
                  <h4>{t("instances.ai.title")}</h4>
                </CardHeader>
                <CardBody>
                  <AIInstance values={values} setFieldValue={setFieldValue} />
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </GridItem>

        <GridItem xs={6}>
          <GridContainer>
            <GridItem xs={12}>
              <Card>
                <CardHeader>
                  <CardIcon color="info">
                    <Assignment />
                  </CardIcon>
                  <h4>{t("instances.new.idetityInfo")}</h4>
                </CardHeader>
                <CardBody>
                  <IndentityIntance errors={errors} touched={touched} />
                </CardBody>
              </Card>
            </GridItem>
            <GridItem xs={12}>
              <Card>
                <CardHeader>
                  <CardIcon color="info">
                    <AssignmentInd />
                  </CardIcon>
                  <h4>{t("instances.new.contactInfo")}</h4>
                </CardHeader>
                <CardBody>
                  <ContactIntance errors={errors} touched={touched} />
                </CardBody>
              </Card>
            </GridItem>

            <GridItem xs={12}>
              <Card>
                <CardHeader>
                  <CardIcon color="info">
                    <AssignmentInd />
                  </CardIcon>
                  <h4>{t("instances.new.dateTest")}</h4>
                </CardHeader>
                <CardBody>
                  <DateTestIntance setFieldValue={setFieldValue} />
                </CardBody>
              </Card>
            </GridItem>

            <GridItem xs={12}>
              <Field
                name={"icons"}
                render={({ field }) => {
                  return (
                    <ImageUploader
                      defaultImages={field.value ? [field.value[480]] : []}
                      withIcon={true}
                      singleImage={true}
                      withLabel={false}
                      withPreview={true}
                      buttonText={t("instances.forms.fields.image.label")}
                      onChange={(image) => {
                        setFieldValue("icon", image);
                      }}
                      imgExtension={[".jpg", ".png"]}
                      maxFileSize={5242880}
                    />
                  );
                }}
              />
            </GridItem>

            <GridContainer justify="center">
              
              <GridItem xs={3}>
                <Link to={{pathname: `/instances/${instanceType}`, state: {paginationState: paginationState} }}>
                  <ButtonIcon icon={Cancel} label={t("instances.cancel")} />
                </Link>
              </GridItem>
              <GridItem xs={3}>
                <ButtonIcon
                  icon={Save}
                  label={t("instances.save")}
                  color={"info"}
                  onClick={() => {
                    submitForm();
                  }}
                />
              </GridItem>
            </GridContainer>
          </GridContainer>
        </GridItem>
      </GridContainer>
    </Form>
  );
};

const EditOpportunityFormWF = withFormik({
  validationSchema: editOportunityFormSchema,
  mapPropsToValues: ({ instance }) => {
    const {
      name,
      address,
      category,
      phone,
      description,
      webPage,
      requirementDescription,
      identification,
      contact,
      timezone,
      city,
      location,
      opportunity,
      icon,
      icons,
      instanceStatus,
      token,
      firebaseProject,
      maxAppUsers,
      canAccessNewApp,
      language,
      aiFeatures
    } = instance;

    return {
      name: name,
      appType: 1,
      address: address,
      category: category,
      phone: phone,
      description: description,
      webPage: webPage,
      maxAppUsers: maxAppUsers,
      instanceStatus: instanceStatus,
      instanceType: "Opportunity",
      requirementDescription: requirementDescription,
      identification: {
        type: identification.type ? identification.type : 0,
        value: identification.value ? identification.value : ''
      },
      contact: {
        name: contact.name,
        phone: contact.phone,
        email: contact.email
      },
      timezone: {
        zone: timezone.zone,
        utc: timezone.utc
      },
      city: {
        id: city.id,
        timezone: city.timezone,
        continentName: city.continentName,
        geonameId: city.geonameId,
        continentCode: city.continentCode,
        countryIsoCode: city.countryIsoCode, 
        subdivisionName: city.subdivisionName,
        cityName: city.cityName,
        countryName: city.countryName
      },
      location: {
        coordinates: [location.coordinates[0], location.coordinates[1]]
      },
      opportunity: {
        dateIn: (opportunity.dateIn ? new Date(opportunity.dateIn) : new Date()),
        dateEnd: (opportunity.dateEnd ? new Date(opportunity.dateEnd) : new Date(Date.now() + 12096e5))
      },
      icon: icon,
      icons: icons,
      token: token,
      firebaseProject: firebaseProject ? firebaseProject : 0,
      canAccessNewApp: canAccessNewApp ?? false,
      language: language || 'es',
      aiFeatures: {
        visitImageScoringEnabled: aiFeatures?.visitImageScoringEnabled ?? false
      }
    };
  },
  handleSubmit: (values, { props }) => {
    props.submitSuccess(values);
  }
})(EditOpportunityForm);

export default EditOpportunityFormWF;
